"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conditionalAttributes = void 0;
/**
* conditionaAttributes is a utillity method that is used to overcome the
* issue that react now has with es6 transforms and spreading attributes.
* @param {*} config
* @returns {Object} - An object containing only the attributes that satisfy the condition (non-null and non-undefined).
*/
const conditionalAttributes = function (conditions) {
  // Handle non-object inputs
  if (!conditions || typeof conditions !== 'object') {
    return {};
  }
  return Object.keys(conditions).reduce((acc, key) => {
    const condition = conditions[key];
    // only return attributes if they don't evaluate to undefined or null
    if (condition !== undefined && condition !== null) {
      return {
        ...acc,
        [key]: condition
      };
    }
    return acc;
  }, {});
};
exports.conditionalAttributes = conditionalAttributes;